// Single source of truth for per-route SEO + the sitemap generator.
// Plain data (no JSX) so both app.jsx and scripts/generate-sitemap.mjs can import it.

export const SITE_URL = "https://www.monitoredgrowth.com";

// TODO(steve): swap in a branded 1200×630 social share image (e.g. /assets/og-default.png).
// Falling back to the logo for now so cards aren't blank.
export const DEFAULT_OG_IMAGE = "/assets/logo.png";

// `id` matches the route id used by goTo()/Nav. `path` is the real URL.
// `sitemap:false` keeps a page out of sitemap.xml; `noindex:true` adds a robots meta tag.
export const PAGES = [
  {
    id: "home",
    path: "/",
    title: "Monitored Growth | Marketing for $1M–$10M Security Companies",
    description:
      "Marketing built for $1M–$10M security dealers and integrators. We speak alarm panels, RMR, attrition, and exit multiples — because we ran marketing inside the industry before building this firm to fix it.",
    priority: "1.0",
  },
  {
    id: "residential",
    path: "/residential",
    title: "Residential Security Marketing for Alarm Dealers | Monitored Growth",
    description:
      "SimpliSafe and Ring are eating your front funnel and attrition is stuck above 12%. We rebuild the demand engine for residential alarm dealers without burning down what already works.",
    priority: "0.9",
  },
  {
    id: "mixed",
    path: "/mixed",
    title: "Mixed Dealer Marketing: Residential + Commercial | Monitored Growth",
    description:
      "One brand, two buyers. We run residential and commercial as parallel funnels so mixed security dealers can rotate toward commercial RMR without losing the residential base that funds it.",
    priority: "0.9",
  },
  {
    id: "commercial",
    path: "/commercial",
    title: "Commercial Security Integrator Marketing | Monitored Growth",
    description:
      "Your buyers don't Google \"commercial security vendor.\" We build authority and named-account penetration so integrators show up credible the moment a facility director enters a buying cycle.",
    priority: "0.9",
  },
  {
    id: "exit",
    path: "/exit",
    title: "Exit Accelerator: Marketing to Expand Your Sale Multiple | Monitored Growth",
    description:
      "A 24-month marketing program for owners of $2M–$10M security companies preparing to sell. Built specifically to expand your sale multiple. Application-only.",
    priority: "0.8",
  },
  {
    id: "guides",
    path: "/guides",
    title: "Field Guides for Security Dealers & Integrators | Monitored Growth",
    description:
      "Free field guides for $1M–$10M security companies: beating SimpliSafe, the mixed-dealer mix-shift playbook, the integrator's authority stack, and the exit multiple multiplier.",
    priority: "0.7",
  },
  {
    id: "about",
    path: "/about",
    title: "About the Founder | Monitored Growth",
    description:
      "25 years in marketing, seven of them inside the security industry. Monitored Growth exists because security operators deserve a partner who already knows the business — not a generalist agency.",
    priority: "0.6",
  },
  {
    id: "caprock-rentals",
    path: "/case-studies/caprock-rentals",
    title: "Caprock Rentals Case Study: Jobsite Security Marketing | Monitored Growth",
    description:
      "Caprock Rentals grew on relationships while its website sat idle. We rebuilt its search foundation around what contractors search for. Now the site brings in calls.",
    image: "/assets/og-caprock.jpg",
    priority: "0.7",
  },
  {
    id: "audit",
    path: "/audit",
    title: "Free AI Visibility Report for Security Companies | Monitored Growth",
    description:
      "See what ChatGPT, Gemini, and Google's AI answers say about your security company today. We run the questions your buyers ask AI and send you a one-page report.",
    // Targeted outreach landing page — kept out of the sitemap and noindexed.
    // TODO(steve): flip these if you want /audit indexed publicly.
    sitemap: false,
    noindex: true,
  },
];

// Convenience lookup by route id, used by the app's <Seo> component.
export const META_BY_ID = PAGES.reduce((acc, p) => {
  acc[p.id] = p;
  return acc;
}, {});
